var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrown = function SvgCrown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.883 55.15 106.78 99.757a4.11 4.11 0 0 1-4.107 3.242H23.977a4.11 4.11 0 0 1-4.107-3.242L10.094 55.15a4.1 4.1 0 0 1 1.48-4.104 4.11 4.11 0 0 1 4.353-.451l23.986 11.613 19.88-35.128a4.108 4.108 0 0 1 7.146 0l19.88 35.17 24.15-11.696a4.11 4.11 0 0 1 4.445.386 4.1 4.1 0 0 1 1.47 4.21Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export default ForwardRef;